var importers = {};
var lazyi18nextBackend = function () { return ({
    type: 'backend',
    init: function (services, backendOptions, i18nextOptions) {
        /* use services and options */
    },
    read: function (language, namespace, callback) {
        if (importers[namespace]) {
            importers[namespace](language, namespace, callback);
        }
        else {
            // eslint-disable-next-line no-console
            console.error('Failed to lazyload resource, did you make a typo in useTranslation()?', namespace, language);
        }
    },
    addImporter: function (ns, func) {
        importers[ns] = func;
    },
    hasImporter: function (ns) {
        return importers.hasOwnProperty(ns);
    },
}); };
export default lazyi18nextBackend;
//# sourceMappingURL=lazyI18nextBackend.js.map